var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashIconAdminPanelWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.61355 4.25C7.17052 4.25 6.27734 5.65264 6.27734 7V17.5C6.27734 18.8474 7.17052 20.25 8.61355 20.25H16.9411C18.3842 20.25 19.2773 18.8474 19.2773 17.5V7C19.2773 5.65264 18.3842 4.25 16.9411 4.25H8.61355ZM7.77734 7C7.77734 6.13822 8.30451 5.75 8.61355 5.75H16.9411C17.2502 5.75 17.7773 6.13822 17.7773 7V17.5C17.7773 18.3618 17.2502 18.75 16.9411 18.75H8.61355C8.30451 18.75 7.77734 18.3618 7.77734 17.5V7ZM9.77734 7C9.36313 7 9.02734 7.33579 9.02734 7.75C9.02734 8.16421 9.36313 8.5 9.77734 8.5H15.7773C16.1916 8.5 16.5273 8.16421 16.5273 7.75C16.5273 7.33579 16.1916 7 15.7773 7H9.77734Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashIconAdminPanelWhite);
export default __webpack_public_path__ + "static/media/dash_icon_admin-panel_white.e3bf7992ba54761de358146eabe2cb06.svg";
export { ForwardRef as ReactComponent };